import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@domain-group/fe-co-button';
import Modal from '@domain-group/fe-co-modal';
import * as styles from '../../styles/homepass-booking/homepass-booking-structure';
import CustomDateInputs from './custom-date-inputs';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CustomDateDialog = props => ___EmotionJSX(Modal, {
  closeCallback: props.closeCallback,
  animated: false,
  idealWidth: 512,
  height: 400
}, ___EmotionJSX("div", {
  css: styles.modalContent
}, ___EmotionJSX("div", {
  css: styles.modalTitle
}, "Request another time"), ___EmotionJSX("div", {
  css: styles.modalSubTitle
}, "When would you like to inspect the property?"), ___EmotionJSX(CustomDateInputs, {
  availableCalendarEvents: props.availableCalendarEvents,
  availableCalendarEventsTimeOptions: props.availableCalendarEventsTimeOptions,
  availableCalendarEventsSelectedDate: props.availableCalendarEventsSelectedDate,
  availableCalendarEventsIndex: props.availableCalendarEventsIndex,
  onDateChange: props.onDateChange,
  onTimeChange: props.onTimeChange
}), ___EmotionJSX("div", {
  css: styles.modalActions
}, ___EmotionJSX(Button, {
  css: styles.modalCancelButton,
  appearance: "link",
  onClick: props.closeCallback
}, "Cancel"), ___EmotionJSX(Button, {
  css: styles.modalOkayButton,
  onClick: props.onDateSelection
}, "Okay"))));
CustomDateDialog.propTypes = {
  /* eslint-disable react/require-default-props */
  availableCalendarEvents: CustomDateInputs.propTypes.availableCalendarEvents,
  availableCalendarEventsTimeOptions: CustomDateInputs.propTypes.availableCalendarEventsTimeOptions,
  availableCalendarEventsSelectedDate: CustomDateInputs.propTypes.availableCalendarEventsSelectedDate,
  availableCalendarEventsIndex: CustomDateInputs.propTypes.availableCalendarEventsIndex,
  onDateChange: CustomDateInputs.propTypes.onDateChange,
  onTimeChange: CustomDateInputs.propTypes.onTimeChange,
  /* eslint-enable react/require-default-props */
  closeCallback: PropTypes.func.isRequired,
  onDateSelection: PropTypes.func.isRequired
};
export default CustomDateDialog;